import React from 'react';
import { Link } from 'react-router-dom';

const DakotaJoy = () => {
  return (
    <div>
      {/* Hero Image Section */}
      <section style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
        <img 
          src="https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/y8bj8t96_Wild%20Honey-Dakota%26Honey-564-Edit-Edit.jpg"
          alt="Honey and Dakota"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </section>

      {/* Title Section */}
      <section style={{ padding: '60px 40px', background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Honey + Dakota
            </h1>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)', marginBottom: '40px' }}>
              Two women. One unforgettable experience. Ready to play?
            </p>
            <Link to="/bookings" className="btn-primary">
              Book Now
            </Link>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8' }}>
              There's something electric about being wanted by two women at once. Dakota and I don't just work well together — we genuinely enjoy each other. And that shows.
            </p>
            
            <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8' }}>
              What happens when you book us together? You'll see us explore each other first. Soft touches. Lingering kisses. A knowing smile as we catch you watching. We want you to take it all in before we pull you into the moment with us.
            </p>
            
            <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8' }}>
              From there, we follow your lead. Want to sit back and let us entertain you? Done. Prefer to be the centre of our attention? Even better. We're intuitive, playful, and completely focused on your pleasure.
            </p>

            <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8' }}>
              The best part? Dakota and I have a natural rhythm together. There's no awkwardness, no figuring each other out on your time. We already know how to move as one — which means you get to fully immerse yourself without a single moment of hesitation.
            </p>

            <p className="body-large" style={{ marginBottom: '48px', lineHeight: '1.8' }}>
              Whether this is your first time with two women or you're a seasoned enthusiast, we'll make sure you leave completely satisfied. No performance. No pressure. Just pure, indulgent pleasure.
            </p>

            <p className="hero-medium" style={{ textAlign: 'center', marginBottom: '16px' }}>
              So… are you ready to see what we can do?
            </p>
            
            <p className="body-large" style={{ textAlign: 'center', fontStyle: 'italic', color: 'var(--text-secondary)' }}>
              We can't wait to meet you,<br />
              Honey + Dakota x
            </p>
          </div>
        </div>
      </section>

      {/* About Dakota Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-subtle)' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 className="heading-1" style={{ marginBottom: '24px', color: 'var(--text-primary)' }}>
              Meet Dakota
            </h2>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              Dakota is everything you want in a companion — smart, playful, and effortlessly sensual. She's got that rare combination of warmth and intensity that makes every moment with her feel both comfortable and charged with possibility. Together, we're an experience you won't forget.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px',
            maxWidth: '1400px',
            margin: '0 auto'
          }}>
            {[
              { id: 'duo-1', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/tjz7txsx_Wild%20Honey-Dakota%26Honey-252-Edit-Edit.jpg' },
              { id: 'duo-2', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/t9mgafb5_Wild%20Honey-Dakota%26Honey-564-Edit-Edit.jpg' },
              { id: 'duo-3', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/w0sk1p54_Wild%20Honey-Dakota%26Honey-266-Edit-Edit-Edit.jpg' },
              { id: 'duo-4', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/zotknrj5_Wild%20Honey-Dakota%26Honey-149-Edit-Edit.jpg' },
              { id: 'duo-5', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/pp7b18n8_Wild%20Honey-Dakota%26Honey-193-Edit-Edit-Edit.jpg' },
              { id: 'duo-6', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/tlitkcas_Wild%20Honey-Dakota%26Honey-184-Edit-Edit.jpg' }
            ].map((image) => (
              <div 
                key={image.id}
                style={{ 
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img 
                  src={image.url}
                  alt={`Honey and Dakota ${image.id}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    transition: 'transform 0.5s cubic-bezier(.645,.045,.355,1)'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 className="heading-1" style={{ marginBottom: '32px', textAlign: 'center' }}>
              Pricing
            </h2>
            
            <div style={{ marginBottom: '32px' }}>
              <p className="body-regular" style={{ marginBottom: '16px', color: 'var(--text-secondary)', textAlign: 'center' }}>
                Private Sydney location • Includes both companions
              </p>
            </div>

            <div style={{ 
              display: 'grid', 
              gap: '16px',
              marginBottom: '48px'
            }}>
              {[
                { duration: '3 hours', price: '$5,500', note: 'Most popular' },
                { duration: '2 hours', price: '$4,000' },
                { duration: '1.5 hours', price: '$3,000' },
                { duration: '1 hour', price: '$2,000', note: 'Minimum booking' }
              ].map((item) => (
                <div 
                  key={item.duration}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '20px 24px',
                    border: '1px solid var(--border-medium)',
                    background: item.note === 'Most popular' ? 'rgba(90, 30, 43, 0.03)' : 'transparent'
                  }}
                >
                  <span className="body-regular">
                    {item.duration} {item.note && <span style={{ color: 'var(--text-light)', fontSize: '14px' }}>({item.note})</span>}
                  </span>
                  <span className="body-regular" style={{ fontWeight: '600', color: 'var(--burgundy)' }}>
                    {item.price}
                  </span>
                </div>
              ))}
            </div>

            <div style={{ 
              padding: '32px',
              background: 'rgba(90, 30, 43, 0.05)',
              borderLeft: '3px solid var(--burgundy)',
              marginBottom: '48px'
            }}>
              <h3 className="heading-3" style={{ marginBottom: '16px' }}>
                Dinner + Duo Experience
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                Want to take us out first? Enjoy drinks and dinner with both of us before we head back to continue the evening in private. The chemistry builds all night, and by the time we're alone together, the anticipation is electric.
              </p>
              <p className="body-regular" style={{ fontWeight: '600', color: 'var(--burgundy)' }}>
                4 hours (2 social + 2 private): $6,000
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <Link to="/bookings" className="btn-primary">
                Book an Experience
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DakotaJoy;
